/*
  pdp-amazon-variant.js — owner 2026-06-12.
  WHAT: Updates the "Available on Amazon" button's href when the user
        switches PDP variant, so each variant points at its own Amazon
        listing.
  WHY:  Owner asked for per-variant Amazon URLs. The button now reads a
        variant→URL map from data-amazon-variant-map on the anchor and
        syncs href on every variant change. Falls back to data-amazon-default
        (product-level URL) when a specific variant has no override.
  WHEN: 2026-06-12.

  How it wires up:
    - pdp-buybox-info.liquid emits the anchor with:
        data-amazon-variant-map='{"39929458819205":"https://...","..."}'
        data-amazon-default="https://...product-level..."
    - The variant picker is a native <fieldset> of radio inputs name="id"
      (per the buybox snippet) OR a <select name="id"> on fallback.
    - On any change event whose target is name="id", we read the current
      value, look up the map, set anchor.href.
    - On DOMContentLoaded we sync once in case ?variant=X was in the URL.
*/

(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.ba-pdp-info__amazon').forEach(function (anchor) {
      var raw = anchor.getAttribute('data-amazon-variant-map');
      if (!raw) return;
      var map;
      try { map = JSON.parse(raw); } catch (e) { return; }
      var fallback = anchor.getAttribute('data-amazon-default') || anchor.href;

      var form = anchor.closest('form');
      if (!form) return;

      function currentVariantId() {
        var radio = form.querySelector('input[name="id"]:checked');
        if (radio) return radio.value;
        var select = form.querySelector('select[name="id"]');
        if (select) return select.value;
        var hidden = form.querySelector('input[type="hidden"][name="id"]');
        if (hidden) return hidden.value;
        return null;
      }

      function sync() {
        var vid = currentVariantId();
        if (!vid) return;
        var url = map[vid] || '';
        // Owner rule 2026-06-12 (revised): if a variant has no direct
        // Amazon listing, fall back to the parent ASIN (data-amazon-default).
        if (!url) url = fallback;
        anchor.style.display = '';
        if (url && anchor.href !== url) anchor.href = url;
      }

      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t && (t.name === 'id' || (t.getAttribute && t.getAttribute('name') === 'id'))) {
          sync();
        }
      });

      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
